(ns shared.core.components.multiselect-checkbox-dropdown
  (:require [clojure.string :as s]
            [shared.core.reactive :as re]
            [shared.core.components.button :as button]
            [shared.core.components.dropdown :as dropdown]
            [shared.core.components.h :as h]
            [shared.core.components.icon :as icon]
            [shared.core.components.input :as input]
            [shared.core.components.label :as lbl]
            [shared.core.components.modals.views :as modal]
            [shared.core.style :as style]
            [shared.core.util :as util]))

(def multicheckbox-path [:multicheckbox-form])
(def pre-icon-style {:color (style/black-rgba 0.4)
                     :font-size 12
                     :left 6})

(re/reg-event-db
  :multiselect/add-item-action
  (fn [db [_ {:keys [form-path form-name default-value-path]}]]
    (let [raw (get-in db (conj multicheckbox-path :item) "")
          trimmed (s/trim (str raw))
          ;; If your multiselect stores numeric IDs, parse here:
          new-val (or (util/parse-int trimmed) trimmed)
          ;; helper to append uniquely and keep a vector
          add-unique (fn [xs v] (-> (or xs [])
                                    (conj v)
                                    set
                                    vec))]
      (if (s/blank? trimmed)
        db
        (-> db
            ;; append to the multiselect value vector
            (update-in (conj form-path form-name) add-unique new-val)
            (update-in (conj form-path default-value-path) add-unique new-val)
            ;; clear the input in the modal form
            (assoc-in (conj multicheckbox-path :item) ""))))))

(defmethod modal/modal-view
  :multiselect/create-new-item [_ {:keys [form-path form-name, default-value-path callback]}]
  [modal/modal {:animate? false
                :background-click nil
                :style {:width 600}}
   [:div {:style {:width "100%"
                  :display "grid"
                  :justify-content "center"
                  :align-items "center"
                  :row-gap "20px"}}
    [:div
     [h/h2 {:style {:text-align "center"}} "Create new item"]]
    [:div
     {:style {:width "100%"}}
     [input/input {:form-path multicheckbox-path
                   :form-name :item
                   :style {:font-size 13
                           :width "100%"}
                   :placeholder "Name"}]]
    [:div {:style {:display "flex"
                   :justify-content "center"
                   :align-items "center"}}

     [button/green-button {:style {:padding "0 6px"
                                   :height "30px"
                                   :width "50%"}
                           :on-click (fn [e]
                                       (util/stop-event e)
                                       (re/dispatch [:multiselect/add-item-action
                                                     {:form-path form-path
                                                      :form-name form-name
                                                      :default-value-path default-value-path}])
                                       (re/dispatch [:modals/hide])
                                       (when callback
                                         (try
                                           (callback)
                                           (catch :default err
                                             (js/console.error "add-item-callback error:" err)))))}
      "Add"]]]])

(defn create-new-item [{:keys [form-path form-name, default-value-path callback]}]
  [:div {:style {:display "flex"
                 :justify-content "center"
                 :align-items "center"
                 :margin-left "10px"}
         :on-click #((re/dispatch [:modals/show [:multiselect/create-new-item [{:form-path form-path :form-name form-name}]]]))}
   [button/green-button {:style {:padding "3px 6px"
                                 :height "auto"}
                         :on-click (fn [e]
                                     (util/stop-event e)    ;; prevent dropdown/menu from eating the click
                                     (re/dispatch
                                       [:modals/show
                                        [:multiselect/create-new-item
                                         {:form-path form-path
                                          :form-name form-name
                                          :default-value-path default-value-path
                                          :callback callback
                                          }]]))}
    [icon/material-icon {:icon-type :add
                         :style {:color :inherit}}]]])


(defn checkbox-list-item [{:keys [text selected?]}]
  [:div {:style {:display :flex
                 :align-items :center}}
   [icon/material-icon {:icon-type (if selected?
                                     :check-box
                                     :check-box-outline-blank)
                        :style (cond-> {:color (style/black-rgba 0.2)
                                        :font-size 12
                                        :flex "0 0 auto"}
                                       selected?
                                       (assoc :color (style/color :blue :shade-1)))}]
   (into [:span {:style {:color (style/black-rgba 0.8)
                         :font-size 12
                         :font-weight style/font-regular-weight
                         :line-height 1.5
                         :flex 1
                         :margin-left 12}}]
         [text])])

(defn multiselect-checkbox-dropdown [{:keys [val-subscribe form-path form-name default-value-path add-item-callback]}]
  (let [val- (if val-subscribe
               (re/subscribe val-subscribe)
               (when (and form-path form-name)
                 (re/subscribe [:form/val- form-path form-name])))
        show-dropdown-filter?* (re/ratom false)
        just-closed?* (re/ratom false)
        initialized?* (re/ratom false)
        search-query* (re/ratom "")]
    (fn [{:keys [value label label-class-name label-info required? label-cmp default-value placeholder
                 search-placeholder container-style input-container-style options dropdown-container-style
                 allow-create-item?]}]
      (let [v (or (some->> (or value (when val- @val-)) (into #{})) #{})
            search-placeholder (or search-placeholder "Search")]

        ;; set default into the form only once if empty
        (when (and (not @initialized?*)
                   (seq default-value)
                   (empty? v)
                   form-path form-name)
          (reset! initialized?* true)
          (re/dispatch [:form/change form-path form-name (vec default-value)]))

        [:div {:style (merge {:position :relative}
                             container-style)}
         [:div
          (when label
            (into [(or label-cmp lbl/label) {:class-name label-class-name
                                             :required? required?
                                             :info-tooltip label-info}]
                  [label]))]

         [:div {:style {:display :flex}}
          [:div {:style (merge {:background-color "#fff"
                                :border (str "1px solid " (util/hex->rgba (style/color :black :base) 0.2))
                                :border-radius 3
                                :display :flex
                                :align-items :center
                                :cursor :pointer
                                :padding "3px 6px 3px 8px"
                                :flex 1}
                               input-container-style)
                 :on-click #(if @just-closed?*
                              (reset! just-closed?* false)
                              (reset! show-dropdown-filter?* (not @show-dropdown-filter?*)))}
           [:span {:style (cond-> {:color (util/hex->rgba (style/color :black :base) 0.8)
                                   :font-size 12
                                   :font-weight style/font-regular-weight
                                   :line-height 1.5
                                   :flex 1
                                   :margin-right 12}
                                  (empty? v)
                                  (assoc :opacity 0.3))}
            (if (empty? v)
              placeholder
              (str (count v) " Selected"))]
           [icon/material-icon {:icon-type :chevron-right
                                :style {:color (util/hex->rgba (style/color :black :base) 0.6)
                                        :font-size 12
                                        :transform "rotate(90deg)"}}]]

          (when allow-create-item?
            [create-new-item {:form-path form-path
                              :form-name form-name
                              :default-value-path default-value-path
                              :callback add-item-callback}])]

         (when @show-dropdown-filter?*
           (let [sel-fn (fn [e d]
                          (let [val (some-> (aget d "value")
                                            (js->clj))]
                            (when (and form-path form-name)
                              (re/dispatch [:form/change
                                            form-path
                                            form-name
                                            (vec (if (contains? v val)
                                                   (disj v val)
                                                   (conj v val)))])))
                          (util/stop-event e))]
             [dropdown/dropdown {:class-name "multiselect-checkbox-dropdown"
                                 :pre-material-icon :search
                                 :pre-icon-style pre-icon-style
                                 :placeholder search-placeholder
                                 :container-style (merge {:position :absolute
                                                          :top 28
                                                          :left 0
                                                          :width "100%"
                                                          :z-index (style/z :medium)}
                                                         dropdown-container-style)
                                 :text search-placeholder
                                 :search-query @search-query*
                                 :on-search-change (fn [_ d]
                                                     (let [query (aget d "searchQuery")]
                                                       (reset! search-query* query)))
                                 :auto-focus? true
                                 :key? false
                                 :close-on-change? false
                                 :on-change sel-fn
                                 :on-close (fn [e d]
                                             ;; Doing this because `e` (event) is null for clicks (was going to check target and correctly handle that way).
                                             ;; There's surely a better solve but this works for now.
                                             ;; Just delaying an indication of recently closed, so we don't immediately open back up.
                                             (reset! just-closed?* true)
                                             (util/wait 200 #(reset! just-closed?* false))
                                             (reset! show-dropdown-filter?* false)
                                             (reset! search-query* ""))
                                 :select-on-navigation? false
                                 :options (if (util/loading? options)
                                            options
                                            (mapv (fn [{:keys [text value search] :as o}]
                                                    (let [selected? (contains? v value)]
                                                      {:text [checkbox-list-item (assoc o :selected? selected?)]
                                                       :value value
                                                       :search (or search (str text " " value))
                                                       :on-click sel-fn}))
                                                  options))}]))]))))
